import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ReactApexChart from 'react-apexcharts';
import { merge } from 'lodash';
import { BaseOptionChart } from './';
import ChartErrorBoundary from '../ChartErrorBoundary';

// props.data expects an array of userrequest objects
export default function OptionUsageDonut({ data = [] }) {
  const counts = data.reduce((acc, row) => {
    const key = (row.option_name || 'unknown').toString();
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  const labels = Object.keys(counts);
  const series = labels.map(l => counts[l]);

  // sanitize series -> ensure numeric finite values
  const sanitizedSeries = series.map(v => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  });
  const total = sanitizedSeries.reduce((s, v) => s + v, 0);

  const options = merge(BaseOptionChart(), {
    chart: { type: 'donut' },
    labels,
    legend: { position: 'bottom', horizontalAlign: 'center' },
    plotOptions: { pie: { donut: { size: '60%' } } }
  });

  // Ensure options.colors exists (fallback) to avoid apexcharts runtime errors
  if (!options.colors || !Array.isArray(options.colors) || options.colors.length === 0) {
    options.colors = ['#1976d2', '#ffb300', '#00aaff', '#9c27b0', '#43a047'];
  }

  // If there's no meaningful data, avoid rendering the chart to prevent parser errors
  const hasData = sanitizedSeries.length > 0 && total > 0;
  const renderSeries = hasData ? sanitizedSeries : [];
  const renderLabels = hasData ? labels : [];
  // nicer tooltip
  options.tooltip = options.tooltip || {};
  options.tooltip.y = options.tooltip.y || {};
  options.tooltip.y.formatter = (val) => (typeof val === 'number' ? `${val} requests` : val);

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography component="h3" variant="subtitle2" gutterBottom>
          Option Usage
        </Typography>
        {hasData ? (
          <ChartErrorBoundary>
            <ReactApexChart options={{ ...options, labels: renderLabels }} series={renderSeries} type="donut" height={260} />
          </ChartErrorBoundary>
        ) : (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>No data to display</Typography>
        )}
      </CardContent>
    </Card>
  );
}
